import React from 'react';
import Field from '../../../../components/Field';
import TextInput from '../../../../components/TextInput';
import Toggle from '../../../../components/Toggle';
import PanelHeading from '../../../../components/PanelHeading';
import { Employee, EmployeeFormData } from '../../config';
import SignaturePlacement from './SignaturePlacement';

interface SignatureTabProps {
  isOpen: boolean;
  employee: Employee;
  draft: EmployeeFormData;
  disabled: boolean;
  onChange: (patch: Partial<EmployeeFormData>) => void;
  onSignatureChanged: () => void;
}

const SignatureTab: React.FC<SignatureTabProps> = ({
  isOpen,
  employee,
  draft,
  disabled,
  onChange,
  onSignatureChanged
}) => (
  <div className="employee-tab">
    <PanelHeading
      title="Signing identity"
      hint="Stamped onto documents this person signs. The details are captured at the moment of signing, so changing them later does not alter documents that have already been issued."
    />
    <div className="pdm-grid pdm-grid--2">
      <Field label="Position title" htmlFor="emp-position-title">
        <TextInput
          id="emp-position-title"
          value={draft.position_title}
          placeholder="e.g. Senior Structural Engineer"
          disabled={disabled}
          onChange={(e) => onChange({ position_title: e.target.value })}
        />
      </Field>
      <Field label="Credentials" htmlFor="emp-credentials">
        <TextInput
          id="emp-credentials"
          value={draft.registration_number}
          placeholder="e.g. RPEQ 12345, NER"
          disabled={disabled}
          onChange={(e) => onChange({ registration_number: e.target.value })}
        />
      </Field>
      <Field
        label="Certified engineer"
        className="span-all"
        hint="Only certified engineers can be the signatory on documents that require a certified signature (e.g. a Certificate of Design Compliance)."
      >
        <Toggle
          checked={draft.is_cpeng}
          disabled={disabled}
          label="CPEng"
          onChange={(checked) => onChange({ is_cpeng: checked })}
        />
      </Field>
    </div>

    <PanelHeading title="Signature image" spaced />
    <SignaturePlacement
      isOpen={isOpen}
      employee={employee}
      value={{
        signature_scale: draft.signature_scale,
        signature_offset_x_mm: draft.signature_offset_x_mm,
        signature_offset_y_mm: draft.signature_offset_y_mm
      }}
      positionTitle={draft.position_title}
      registrationNumber={draft.registration_number}
      onChange={onChange}
      onSignatureChanged={onSignatureChanged}
    />
  </div>
);

export default SignatureTab;
